// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Styles custom
import './scss/pages/agencies'

// Agencies map
async function getAgenciesMap ($f) {
  import(/* webpackChunkName: "agenciesMap", webpackPrefetch: true */ './js/components/agenciesMap.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Offers Search Form
async function getOsForm ($f) {
  import(/* webpackChunkName: "offersSearchForm" */ './js/components/offersSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agencies Search Form
async function getAsForm ($f) {
  import(/* webpackChunkName: "agenciesSearchForm", webpackPrefetch: true */ './js/components/agenciesSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Offers Autocomplete
async function getOffersAutocomplete ($f) {
  import(/* webpackChunkName: "offersAutocomplete" */ './js/components/offersAutocomplete.js').then(module => {
    module.offersAutocomplete.init($f)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then(module => {
    module.agenciesAutocomplete.init($f)
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "customLists" */ './js/components/customLists.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html,body').animate({ scrollTop: $('#events-pagination').offset().top - h - p - 10 }, 300)
    })
  })
}

// Contact Form
async function getCForm ($f, initializeEstimate = false) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
    if (initializeEstimate) { $(document).trigger('startEstimate') }
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion de la recherche d'offres
  const $b = $('form[name="osForm"]')
  if ($b.length) {
    $b.waypoint(function () {
      $b.load()
      getOsForm($b)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion de la recherche d'agences la plus proche
  const $c = $('form[name="asForm"]')
  if ($c.length) {
    $c.waypoint(function () {
      $c.load()
      getAsForm($c)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des offres autocomplete
  $('form[name="osForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getOffersAutocomplete($(this).parents('form'))
  })

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })

  // gestion des scrollbars améliorées
  const $l = $('.custom-lists')
  if ($l.length) {
    $l.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $d = $('.pajinate')
  if ($d.length) {
    $d.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire de contact
  const $f = $('form[name="cForm"]')
  $f.waypoint(function () {
    $f.load()
    getCForm($f)
    this.destroy()
  }, {
    offset: '100%'
  })

  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des agences
    const $a = $('#map-agencies')
    const $b = $('#map-detail')
    if ($a.length) {
      $a.waypoint(function () {
        $a.load()
        getAgenciesMap($a)
        this.destroy()
      }, {
        offset: '100%'
      })
    } else if ($b.length) {
      $b.waypoint(function () {
        $b.load()
        getAgenciesMap($b)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  })
})
